module.exports = __webpack_public_path__ + "i18n/translation-es.e74781f3.json";